var map = {
	"./feature_buy_cn.png": 85620,
	"./feature_buy_en.png": 48434,
	"./feature_buy_id.png": 53980,
	"./feature_buy_ko.png": 58325,
	"./feature_buy_ph.png": 80755,
	"./feature_buy_th.png": 90207,
	"./feature_buy_zh.png": 277
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28588;